module.exports = __webpack_public_path__ + "static/media/service_temp_2.da9ba988.jpg";